<div class="page-container h-100">
    <mat-sidenav-container class="d-flex h-100">
      <!-- Left Sidebar -->
      <mat-sidenav class="left-side-bar" #leftSidenav mode="side" opened position="start"
                   (opened)="adjustAddComponentWidth()" (closed)="adjustAddComponentWidth()">
        <div class="main-content d-flex flex-column justify-content-between h-100">
          <div class="cdc-form-field actif d-flex flex-row align-items-center gap-2">
            <input [(ngModel)]="searchComponentsFilters.text" matInput type="text" placeholder="{{ 'Search' | translate }}">

            <mat-icon class="clickable" [matMenuTriggerFor]="options" matTooltip="{{'Filters' | translate}}">filter_list</mat-icon>
            <mat-menu class="more-menu" #options="matMenu">
              <div class="filter-menu-grid" (click)="$event.stopPropagation()">

                <div class="filter-column">
                  <div class="filter-section-title">{{ "Component" | translate }}</div>

                  <div class="cdc-form-field actif">
                    <div class="cdc-label">{{ 'Type' | translate }}</div>
                    <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
                      <mat-select [(value)]="searchComponentsFilters.types" multiple (click)="$event.stopPropagation()">
                        <mat-option *ngFor="let type of componentDisplayTypes" [value]="type.value">{{ type.label | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <mat-checkbox [(ngModel)]="searchComponentsFilters.onlyMultiple" (click)="$event.stopPropagation()">
                    {{ 'Only multiple answers' | translate }}
                  </mat-checkbox>
                </div>

                <div class="filter-column">
                  <div class="filter-section-title">{{ "Roles" | translate }}</div>
                  <div class="cdc-form-field actif">
                    <div class="cdc-label">{{ 'Accessibility' | translate }}</div>
                    <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
                      <mat-select [(ngModel)]="searchComponentsFilters.accessibility" (click)="$event.stopPropagation()">
                        <mat-option value=""></mat-option>
                        <mat-option *ngFor="let type of permissionTypes" [value]="type">{{ type | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="cdc-form-field" [ngClass]="{'actif': searchComponentsFilters.accessibility}">
                    <div class="cdc-label">{{ 'Included' | translate }}</div>
                    <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
                      <mat-select [(ngModel)]="searchComponentsFilters.includedRole" (click)="$event.stopPropagation()" [disabled]="!searchComponentsFilters.accessibility">
                        <mat-option value=""></mat-option>
                        <mat-option *ngFor="let type of roleTypes" [value]="type.value">{{ type.key | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="cdc-form-field" [ngClass]="{'actif': searchComponentsFilters.accessibility}">
                    <div class="cdc-label">{{ 'Excluded' | translate }}</div>
                    <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
                      <mat-select [(ngModel)]="searchComponentsFilters.excludedRole" (click)="$event.stopPropagation()" [disabled]="!searchComponentsFilters.accessibility">
                        <mat-option value=""></mat-option>
                        <mat-option *ngFor="let type of roleTypes" [value]="type.value">{{ type.key | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="filter-column">
                  <div class="filter-section-title">{{ "Others" | translate }}</div>

                  <mat-checkbox [(ngModel)]="searchComponentsFilters.onlyNew" (click)="$event.stopPropagation()">
                    {{ 'Only new' | translate }}
                  </mat-checkbox>

                  <mat-checkbox [(ngModel)]="searchComponentsFilters.onlyConditions" (click)="$event.stopPropagation()">
                    {{ 'Only conditioned' | translate }}
                  </mat-checkbox>

                  <mat-checkbox [(ngModel)]="searchComponentsFilters.onlyConnections" (click)="$event.stopPropagation()">
                    {{ 'Only connected' | translate }}
                  </mat-checkbox>

                  <mat-checkbox [(ngModel)]="searchComponentsFilters.withKeyIndicatorWeight" (click)="$event.stopPropagation()" [disabled]="searchComponentsFilters.withoutKeyIndicatorWeight">
                    {{ 'Only with key indicator weight' | translate }}
                  </mat-checkbox>

                  <mat-checkbox [(ngModel)]="searchComponentsFilters.withoutKeyIndicatorWeight" (click)="$event.stopPropagation()" [disabled]="searchComponentsFilters.withKeyIndicatorWeight">
                    {{ 'Only without key indicator weight' | translate }}
                  </mat-checkbox>
                </div>
              </div>
            </mat-menu>

            <mat-icon class="clickable" matTooltip="{{'Reset' | translate}}" (click)="resetDisplayFilter()">refresh</mat-icon>
          </div>

          <mat-nav-list class="cdc-list"
                        cdkDropList
                        #blocksList="cdkDropList"
                        [cdkDropListData]="page.blocks!"
                        (cdkDropListDropped)="dropBlock($event, page.blocks!)">
            <mat-expansion-panel
              *ngFor="let block of page.blocks; let i = index"
              [hidden]="!shouldDisplayBlock(block)"
              (opened)="openBlock(i)"
              [expanded]="currentStep === i"
              class="left-side-bar-panel"
              cdkDrag
            >
              <mat-expansion-panel-header class="left-side-bar-panel-header">
                <mat-panel-title class="sideBarPanelTitle">
                  <div class="sideBarBlock"
                       [ngClass]="{'selected': selectedBlock?.id === block.id, 'new-panel': newBlocksIds.includes(block.id)}"
                       [matTooltip]="block!.title!"
                       tooltipTruncate>
                    <mat-icon>crop_square</mat-icon>
                    <span #blockTitle class="block-title">
                      {{ block.title }}
                    </span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div cdkDropList
                #groupsList="cdkDropList"
                [cdkDropListData]="block.componentGroups!"
                (cdkDropListDropped)="dropGroup($event, block.id!, block.componentGroups)"
              >
                <ng-container *ngFor="let group of block.componentGroups" >
                  <div cdkDrag>
                    <div *ngFor="let component of group.components">
                      <mat-list-item
                      *ngIf="shouldDisplayComponent(component)"
                      (click)="onComponentSelected(component.id, group.id)"
                      class="p-0">
                        <div class="sideBarOption" [ngClass]="{'selected': selectedComponent?.id === component.id, 'new-panel': newComponentsIds.includes(component.id)}"
                             [matTooltip]="(component.title! || component.config!.placeholder! || component.config!.text!)"
                             tooltipTruncate>
                          <div *ngIf="component.type === ComponentType.INPUT && component.config?.inputType === InputType.TEXT" class="text-cursor-icon"></div>
                          <mat-icon *ngIf="component.type === ComponentType.INPUT && component.config?.inputType === InputType.TEXT_AREA">text_format</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.INPUT && component.config?.inputType === InputType.NUMBER">looks_one</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.INPUT && component.config?.inputType === InputType.DATE">date_range</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.INPUT && component.config?.inputType === InputType.COLOR_PICKER">color_lens</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.INPUT && component.config?.inputType === InputType.FILE">attach_file</mat-icon>

                          <mat-icon *ngIf="component.type === ComponentType.SELECT && component.config?.selectType === SelectType.LIST_DROP">list_alt</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.SELECT && component.config?.selectType === SelectType.LIST_NO_DROP">format_list_bulleted</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.SELECT && component.config?.selectType === SelectType.LIST_CARD">grid_view</mat-icon>

                          <mat-icon *ngIf="component.type === ComponentType.CHECKBOX">check_box</mat-icon>

                          <mat-icon *ngIf="component.type === ComponentType.SCHEDULE">schedule</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.BUTTON">insert_link</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.TEXT">text_fields</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.TITLE">title</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.HTML">code</mat-icon>

                          <mat-icon *ngIf="component.type === ComponentType.ADDRESS">location_on</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.INTITULE">person</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.URL">http</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.VISUAL_PUBLICATION">image</mat-icon>
                          <mat-icon *ngIf="component.type === ComponentType.ACTIVITY_PRESTATIONS">business_center</mat-icon>

                          <span #textElement>{{ component.title || component.config?.placeholder || component.config?.text }}</span>
                        </div>
                      </mat-list-item>
                    </div>
                  </div>

                </ng-container>
              </div>

            </mat-expansion-panel>
          </mat-nav-list>

          <button mat-button class="cdc-button add-block-btn" (click)="onAddBlock()">
            <mat-icon>add</mat-icon>{{'Add' | translate}}
          </button>
        </div>

      </mat-sidenav>


      <!-- Main Content Area -->
      <mat-sidenav-content class="main-content-area">

        <mat-toolbar class="cdc-header">

          <div class="page-titles">
            <span *ngIf="this.page.parentPage !== undefined && this.page.parentPage !== null"
                  #parentName
                  class="parent-title"
                  [matTooltip]="getParentName()" tooltipTruncate>
              {{ getParentName() }}
            </span>

            <span *ngIf="this.page.parentPage !== undefined && this.page.parentPage !== null">></span>

            <span #pageTitle
                  class="page-title"
                  [matTooltip]="page.title!"
                  tooltipTruncate>
              {{ page.title }}
            </span>
          </div>

          <div class="d-flex flex-row align-items-center gap-2">
            <button mat-stroked-button class="cdc-button" *ngIf="!page.current" (click)="onRestorePage()" matTooltip="{{ 'Restore' | translate }}">
              <mat-icon class="m-0">swap_horiz</mat-icon>
            </button>
            <button mat-stroked-button class="cdc-button" (click)="onSave()">
              <mat-icon>save</mat-icon>{{ 'Save' | translate }}
            </button>
            <button mat-stroked-button class="cdc-button" matTooltip="{{ 'More' | translate }}" [matMenuTriggerFor]="morePage">
              <mat-icon class="m-0">more_vert</mat-icon>
            </button>
            <mat-menu class="more-menu" #morePage="matMenu" xPosition="before">
              <button class="more-menu-item" mat-menu-item (click)="buildSideBarSettings('page', undefined,undefined)">
                <mat-icon>settings</mat-icon>
                <span>{{'Settings' | translate}}</span>
              </button>
              <button class="more-menu-item" mat-menu-item (click)="onOpenPreviewPageModal()">
                <mat-icon>remove_red_eye</mat-icon>
                <span>{{'Preview' | translate}}</span>
              </button>
              <button class="more-menu-item" mat-menu-item (click)="onOpenTagsModal()">
                <mat-icon>label</mat-icon>
                <span>{{'Tags' | translate}}</span>
              </button>
              <button class="more-menu-item" mat-menu-item (click)="onOpenPageHistoryModal()">
                <mat-icon>history</mat-icon>
                <span>{{'Versions' | translate}}</span>
              </button>
              <button class="more-menu-item" mat-menu-item (click)="onImportExternalPage()">
                <mat-icon>file_upload</mat-icon>
                <span>{{'Import' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </mat-toolbar>

        <div class="d-flex w-100 h-100 justify-content-center">
          <div class="d-flex justify-content-start align-items-center w-100">
            <button (click)="leftSidenavToggle()" matTooltip="{{ 'Blocks' | translate }}"
                    class="expand-button-right">
              <mat-icon class="side-bar-icon">menu</mat-icon>
            </button>
          </div>

          <div #mainContent *ngIf="page.blocks!.length > 0" class="main-content main-content-display col-11 col-lg-11 col-md-11 d-flex flex-column align-items-center">
            <div *ngFor="let block of page.blocks; let i = index" [hidden]="i !== currentStep" class="block-list-item w-100 h-100">
              <app-block-config #blockComponent
                                [page]="page"
                                [block]="block"
                                [activeRightSideBar]="activeRightSideBar"
                                [selectedBlock]="selectedBlock !== null"
                                [selectedGroupId]="selectedGroup !== null ? selectedGroup.id : null"
                                [selectedComponentId]="selectedComponent !== null ? selectedComponent.id : null"
                                [connectionsDefinitions]="connectionsDefinitions"
                                (buildSideBarSettingsBlock)="buildSideBarSettings('block', undefined, undefined)"
                                (groupSelected)="buildSideBarSettings('group', $event, undefined)"
                                (componentSelected)="buildSideBarSettings('component', $event.groupId, $event.componentId, $event.open)"
                                (newComponent)="onAddComponent($event.groupId, $event.componentId)"
                                (newUpdate)="newUpdateListener()"
                                style="position:relative">
              </app-block-config>
            </div>

            <div #stepper class="stepper">
              <div class="progress-bar progress-bar-desktop">
                <div class="step"
                     *ngFor="let block of page.blocks; let i = index"
                     (click)="goToStep(i)"
                     [class.check]="i <= currentStep">
                </div>
              </div>

              <div class="navigation">
                <div class="button-wrapper-left">
                  <button class="cdc-button previous" mat-flat-button (click)="previousStep()" [disabled]="currentStep === 0" [ngClass]="{ 'deactivated': currentStep === 0 }">
                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
                      <!-- Generator: Adobe Illustrator 29.2.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 116)  -->
                      <defs>
                        <style>
                          .st0 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <polygon class="st0" points="8.9 16.3 3 9.6 8.9 2.9 10.4 4.3 5.7 9.6 10.4 15 8.9 16.3" />
                    </svg>
                    {{isMobile ? '' : ('Previous' | translate)}}
                  </button>
                </div>
                <div class="button-wrapper-right">
                  <button class="cdc-button next" mat-flat-button (click)="nextStep()" [disabled]="currentStep === page.blocks!.length-1" [ngClass]="{ 'deactivated': currentStep === page.blocks!.length-1 }">
                    {{isMobile ? '' : ('Next' | translate)}}
                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
                      <!-- Generator: Adobe Illustrator 29.2.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 116)  -->
                      <defs>
                        <style>
                          .st0 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <polygon class="st0" points="5.1 16.3 3.6 15 8.3 9.6 3.6 4.3 5.1 2.9 10.9 9.6 5.1 16.3" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div *ngIf="page.blocks!.length === 0" class="main-content col-11 col-lg-11 col-md-11 d-flex flex-column align-items-center justify-content-center">
            <span>{{'Empty' | translate}}</span>
          </div>

          <span class="page-version" [ngClass]="{ 'isEdited': isEdited }" [matTooltip]="isEdited ? ('Changed' | translate) : ''" matTooltipPosition="right">
            <span [innerHTML]="VersionBoldIndex(page.version)"></span>
            <b *ngIf="page.current && !isImported"> ({{ 'Current' | translate }})</b>
            <b *ngIf="!page.current && !isImported"> ({{ page.updatedDate | date:'dd/MM/yyyy HH:mm:ss' }})</b>
            <b *ngIf="isImported"> ({{ 'Imported' | translate }})</b>
            <span *ngIf="isEdited">*</span>
          </span>

          <div class="d-flex justify-content-end align-items-center w-100">
            <button (click)="rightSidenavToggle()" matTooltip="{{ 'Settings' | translate }}"
                    class="expand-button-left">
              <mat-icon class="side-bar-icon">menu</mat-icon>
            </button>
          </div>
        </div>

      </mat-sidenav-content>


      <!-- Right Sidebar -->
      <mat-sidenav #rightSidenav mode="side"
                   position="end"
                   class="main-content right-side-bar"
                   (opened)="adjustAddComponentWidth()" (closed)="adjustAddComponentWidth()">

        <!-- page settings -->
        <div *ngIf="activeRightSideBar === 'pageSettings'" class="page-settings">
          <app-page-config-elem-menu
            [elementType]="ElementType.PAGE"
            [copiedElements]="copiedElements"
            [page]="page"
            [selectedBlock]="selectedBlock"
            [selectedGroup]="selectedGroup"
            [selectedComponent]="selectedComponent"
            (copyAction)="updateCopiedElements($event)"
            (clearAction)="updateCopiedElements([])"
            (pasteAction)="pasteAction($event.newComponentIds, $event.newBlockId, $event.lastIndex)"
          >
          </app-page-config-elem-menu>

          <mat-nav-list class="cdc-list">
            <!-- general -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"General" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Title" | translate }}
                </div>

                <input matInput type="text" [(ngModel)]="page.title" (ngModelChange)="newUpdateListener()">
              </div>

              <div class="cdc-form-field" [ngClass]="{'actif': !isParent}">
                <div class="cdc-label">
                  {{ 'Parent' | translate }}
                </div>

                <select [(ngModel)]="page.parentPage" [compareWith]="comparePages" matNativeControl [disabled]="isParent" [matTooltip]="isParent ? ('This page is already a parent' | translate) : ''" (ngModelChange)="newUpdateListener()">
                  <option [ngValue]="null">{{'Without parent' | translate}}</option>
                  <option *ngFor="let parent of pagesParentAvailable" [ngValue]="parent">{{ parent.title }}</option>
                </select>

              </div>

              <div class="cdc-form-field">
                <div class="cdc-label">
                  {{ 'Type' | translate }}
                </div>

                <input matInput type="text" [(ngModel)]="PageType[page.type!]" [disabled]="true">
              </div>

              <div class="cdc-form-field actif" *ngIf="page.type === PageType.CUSTOMER">
                <div class="cdc-label">
                  {{ "Order" | translate }}
                </div>

                <input matInput type="number" [(ngModel)]="page.order" (ngModelChange)="newUpdateListener()">
              </div>
            </mat-expansion-panel>

            <!-- roles -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Roles and guide" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <app-roles [id]="page.id" [roles]="page.roles!" [fullRoles]="fullRoles" [type]="'page'" [isEditColumnVisible]="true" (rolesChanged)="updateRoles($event.type, $event.roleType)" (customerNotVisible)="resetFieldsOnRolesChange($event)" class="d-flex flex-column"></app-roles>

            </mat-expansion-panel>

            <!-- Summary Block -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Summary" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Submit Button" | translate }}
                </div>

                <input matInput type="text" [(ngModel)]="page.blockSummary!.submitButtonText" [placeholder]="'Validate' | translate" (ngModelChange)="newUpdateListener()">
              </div>
            </mat-expansion-panel>

            <!-- Done Block -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"After Submition" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "After submition message" | translate }}
                </div>
                  <angular-editor #editorBlockDoneTextArea [config]="config" (ngModelChange)="onEditorBlockDoneChange($event)" [(ngModel)]="editorBlockDoneText"></angular-editor>
              </div>
              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Close Button (Embed)" | translate }}
                </div>

                <input matInput type="text" [(ngModel)]="page.blockDone!.buttonText" [placeholder]="'Close window' | translate" (ngModelChange)="newUpdateListener()">
              </div>
            </mat-expansion-panel>
          </mat-nav-list>
        </div>

        <!-- block settings -->
        <div *ngIf="activeRightSideBar === 'blockSettings' && selectedBlock" class="block-settings">
            <app-page-config-elem-menu
              [elementType]="ElementType.BLOCK"
              [copiedElements]="copiedElements"
              [page]="page"
              [selectedBlock]="selectedBlock"
              [selectedGroup]="selectedGroup"
              [selectedComponent]="selectedComponent"
              (copyAction)="updateCopiedElements($event)"
              (clearAction)="updateCopiedElements([])"
              (pasteAction)="pasteAction($event.newComponentIds, $event.newBlockId, $event.lastIndex)"
            >
            </app-page-config-elem-menu>

          <!-- block settings -->
          <mat-nav-list class="cdc-list">
            <!-- general -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"General" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Title" | translate }}
                </div>

                <input matInput type="text" [(ngModel)]="selectedBlock!.title" (ngModelChange)="newUpdateListener()">
              </div>

              <div class="cdc-form-field actif" *ngIf="page.type !== PageType.CUSTOMER">
                <div class="cdc-label">
                  {{ "SubOffer" | translate }}
                </div>

                <input matInput type="text" [(ngModel)]="selectedBlock!.subCode" (input)="componentSubcodeChanged()" placeholder="{{'All offers' | translate}}" (ngModelChange)="newUpdateListener()">
              </div>

              <div class="cdc-form-field">
                <mat-checkbox [checked]="selectedBlock!.isMultiple"
                              [(ngModel)]="selectedBlock!.isMultiple"
                              *ngIf="selectedBlock!.subCode != undefined && selectedBlock!.subCode != ''"
                              (ngModelChange)="newUpdateListener()">
                  {{ 'Multiple' | translate }}
                </mat-checkbox>
              </div>
            </mat-expansion-panel>

            <!-- roles -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Roles and guide" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <app-roles [id]="selectedBlock.id" [roles]="selectedBlock.roles" [fullRoles]="fullRoles" [type]="'block'" [isEditColumnVisible]="true" (rolesChanged)="updateRoles($event.type, $event.roleType)" (customerNotVisible)="resetFieldsOnRolesChange($event)" class="d-flex flex-column"></app-roles>

            </mat-expansion-panel>
          </mat-nav-list>

          <button mat-button class="cdc-button delete rem-block-btn" (click)="onRemoveBlock()">
            <span>{{'Delete' | translate}}</span>
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <!-- group settings -->
        <div *ngIf="activeRightSideBar === 'groupSettings' && selectedGroup" class="group-settings">
          <app-page-config-elem-menu [elementType]="ElementType.GROUP"
                                     [copiedElements]="copiedElements"
                                     [page]="page"
                                     [selectedBlock]="selectedBlock"
                                     [selectedGroup]="selectedGroup"
                                     [selectedComponent]="selectedComponent"
                                     (copyAction)="updateCopiedElements($event)"
                                     (clearAction)="updateCopiedElements([])"
                                     (pasteAction)="pasteAction($event.newComponentIds, $event.newBlockId, $event.lastIndex)">
          </app-page-config-elem-menu>

          <mat-nav-list class="cdc-list">
            <!-- General -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"General" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Title" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedGroup!.title" rows="1" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'title')"></textarea>
              </div>

              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Description" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedGroup!.description" rows="3" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'description')"></textarea>
              </div>
              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Help Text" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedGroup!.helpText" rows="1" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'helpText')"></textarea>
              </div>

            </mat-expansion-panel>
            <!-- Quantity -->
            <mat-expansion-panel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Quantity" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <app-multiple-config [multipleConfig]="selectedGroup!.multipleConfig!"
                                   [isGroup]="true"
                                   [hasIndexText]="true"
                                   class="cdc-list"
                                   (multipleChange)="newUpdateListener()">
              </app-multiple-config>

            </mat-expansion-panel>
          </mat-nav-list>



          <button mat-button class="cdc-button delete w-100" (click)="onRemoveGroup()">
            <span>{{'Delete' | translate}}</span>
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <!-- component settings -->
        <div *ngIf="activeRightSideBar === 'componentSettings' && selectedComponent" class="component-settings">
          <app-page-config-elem-menu
            [elementType]="ElementType.COMPONENT"
            [copiedElements]="copiedElements"
            [page]="page"
            [selectedBlock]="selectedBlock"
            [selectedGroup]="selectedGroup"
            [selectedComponent]="selectedComponent"
            (copyAction)="updateCopiedElements($event)"
            (clearAction)="updateCopiedElements([])"
            (pasteAction)="pasteAction($event.newComponentIds, $event.newBlockId, $event.lastIndex)"
          >
          </app-page-config-elem-menu>

          <mat-nav-list class="cdc-list">
            <!-- general -->
            <mat-expansion-panel #generalPanel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"General" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field">
                <div class="cdc-label">
                  {{ "Type" | translate }}
                </div>

                <input matInput type="text" [value]="ComponentType[selectedComponent.type!] | translate" [disabled]="true">
              </div>

              <div class="cdc-form-field" *ngIf="selectedComponent.type === ComponentType.SELECT || selectedComponent.type === ComponentType.INPUT" [ngClass]="{'actif': selectedComponent.type === ComponentType.SELECT}">
                <div class="cdc-label">{{ 'Subtype' | translate }}</div>
                <select [(ngModel)]="selectedComponent.config!.selectType" inactif matNativeControl (ngModelChange)="handleSelectType($event)" *ngIf="selectedComponent.type === ComponentType.SELECT">
                  <option *ngFor="let type of selectTypes" [value]="type.value">{{ type.key | translate }}</option>
                </select>

                <input matInput type="text" [value]="InputType[selectedComponent.config?.inputType!] | translate" [disabled]="true" *ngIf="selectedComponent.type === ComponentType.INPUT">
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type !== ComponentType.TEXT && selectedComponent.type !== ComponentType.BUTTON && selectedComponent.type !== ComponentType.TITLE && selectedComponent.type !== ComponentType.HTML">
                <div class="cdc-label">
                  {{ "Connection tag" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedComponent.tag" rows="1" (focusin)="adjustTextareaHeight($event)" (input)="componentTagChanged($event, 'tag')" class="general-text-area" (focusout)="fixText($event, 'tag')"></textarea>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type !== ComponentType.TEXT && selectedComponent.type !== ComponentType.BUTTON && selectedComponent.type !== ComponentType.TITLE && selectedComponent.type !== ComponentType.HTML">
                <div class="cdc-label">
                  {{ "Export tag" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedComponent.exportTag" rows="1" (focusin)="adjustTextareaHeight($event)" (input)="componentTagChanged($event, 'exportTag')" class="general-text-area" (focusout)="fixText($event, 'exportTag')"></textarea>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type !== ComponentType.HTML">
                <div class="cdc-label">
                  {{ "Title" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedComponent.title" rows="1" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'title')"></textarea>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type !== ComponentType.TITLE && selectedComponent.type !== ComponentType.HTML">
                <div class="cdc-label">
                  {{ "Description" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedComponent.description" rows="3" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'description')"></textarea>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type == ComponentType.TEXT || selectedComponent.type == ComponentType.HTML || selectedComponent.type == ComponentType.CHECKBOX">
                <div class="cdc-label">{{ 'Text' | translate }}</div>
                <ng-container *ngIf="selectedComponent.type == ComponentType.HTML; else elseBlock">
                  <angular-editor #editorTextArea [config]="config" (ngModelChange)="onEditorChange($event)" [(ngModel)]="editorText"></angular-editor>
                </ng-container>
                <ng-template #elseBlock>
                  <textarea #autoResizeTextarea matInput [(ngModel)]="selectedComponent.config!.text" rows="3" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'text')"></textarea>
                </ng-template>
              </div>

              <div class="cdc-form-field actif">
                <div class="cdc-label">
                  {{ "Help Text" | translate }}
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedComponent.helpText" rows="1" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'helpText')"></textarea>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type === ComponentType.INPUT && selectedComponent.config?.inputType === InputType.TEXT">
                <div class="cdc-label">
                  {{ "Mask" | translate }}
                </div>
                <div class="d-flex gap-1">
                  <select [ngClass]="{
                            'validator-select': maskSelected === 'CUSTOM' || maskSelected === 'NONE'
                          }"
                          [(ngModel)]="maskSelected"
                          inactif
                          matNativeControl
                          (ngModelChange)="onSelectMask(maskSelected)">
                    <option value="NONE">--{{'None' | translate}}--</option>
                    <option disabled>──────────</option>
                    <option *ngFor="let mask of maskConfigs" [value]="mask.type">{{ mask.type | translate }}</option>
                    <option *ngIf="maskSelected === 'CUSTOM'" value="CUSTOM" hidden>{{'Custom' | translate}}</option>
                  </select>
                  <textarea *ngIf="maskSelected === 'CUSTOM' || maskSelected === 'NONE'"
                    class="validator-text"
                    #autoResizeTextarea
                    matInput
                    [(ngModel)]="selectedComponent.config!.mask!.mask"
                    rows="1"
                    (focusin)="adjustTextareaHeight($event)"
                    (input)="handleMaskInput($event)"
                    (focusout)="fixText($event, 'mask')">
                  </textarea>

                  <mat-icon *ngIf="maskSelected === 'CUSTOM' || maskSelected === 'NONE'"
                    class="component-title-help"
                    matTooltipClass="multiline-tooltip"
                    [matTooltip]="
                      '0 : ' + ('Numerical character' | translate) + '\n' +
                      'X : ' + ('Numerical character' | translate) + '\n' +
                      '9 : ' + ('Numerical character' | translate) + ' (' + ('optional' | translate) + ')\n' +
                      'A : ' + ('Alphanumeric character' | translate) + '\n' +
                      'S : ' + ('Alphabetic character' | translate) + '\n' +
                      'U : ' + ('Alphabetic character' | translate) + ' (' + ('uppercase' | translate) + ')\n' +
                      'L : ' + ('Alphabetic character' | translate) + ' (' + ('lowercase' | translate) + ')\n' +
                      '* : ' + ('Quantifier for indefinite repetition (Ex: \'A*\' accepts an infinite sequence of alphanumeric characters)' | translate)
                    "
                    [matTooltipPosition]="'left'">help</mat-icon>
                </div>
              </div>

              <div class="cdc-form-field"
                   *ngIf="selectedComponent.type === ComponentType.INPUT && selectedComponent.config?.inputType === InputType.TEXT"
                   [ngClass]="{
                'actif': !disableRegex(selectedComponent)
              }">
                <div class="cdc-label">
                  {{"Validator" | translate}}
                </div>

                <div class="d-flex gap-1">
                  <select class="validator-select"
                          [(ngModel)]="regexSelected"
                          inactif
                          matNativeControl
                          (ngModelChange)="onSelectRegex(regexSelected)"
                          [disabled]="disableRegex(selectedComponent)"
                          [matTooltip]="disableRegex(selectedComponent) ? ('Disabled due to non-editable customer role or read only' | translate) : ''">
                    <option value="Empty">--{{'None' | translate}}--</option>
                    <option disabled>──────────</option>
                    <option *ngFor="let regex of regexTypes" [value]="regex.type">{{ regex.type | translate }}</option>
                    <option *ngIf="customRegex" value="Custom" hidden>{{'Custom' | translate}}</option>
                  </select>
                  <textarea class="validator-text"
                  #autoResizeTextarea
                            matInput
                            [(ngModel)]="selectedComponent.regex"
                            rows="1"
                            (focusin)="adjustTextareaHeight($event)"
                            (input)="handleRegexInput($event)"
                            (focusout)="fixText($event, 'regex')"
                            [disabled]="disableRegex(selectedComponent)"
                            [matTooltip]="disableRegex(selectedComponent) ? ('Disabled due to non-editable customer role or read only' | translate) : ''">
              </textarea>
                </div>
              </div>

              <div class="cdc-form-field" [ngClass]="{'actif': selectedComponent.size! <= 12 && selectedComponent.size! >= 1}">
                <div class="cdc-label">
                  {{ "Width" | translate }}
                </div>
                <div class="cdc-label-description">({{ 'Range between' | translate }} 2-12)</div>
                <input matInput type="number" [(ngModel)]="selectedComponent.size" [min]="2" [max]="12" step="1" (ngModelChange)="onWidthChanged($event)">
              </div>

              <div class="cdc-form-field">
                <mat-checkbox [checked]="selectedComponent!.readOnly"
                              [(ngModel)]="selectedComponent!.readOnly"
                              *ngIf="selectedComponent.type != ComponentType.TEXT && selectedComponent.type != ComponentType.BUTTON && selectedComponent.type !== ComponentType.TITLE && selectedComponent.type !== ComponentType.HTML"
                              (ngModelChange)="onReadOnlyUpdate()">
                  {{ 'Read only' | translate }}
                </mat-checkbox>
              </div>

              <div class="cdc-form-field">
                <mat-checkbox [checked]="selectedComponent!.isRequired"
                              [(ngModel)]="selectedComponent!.isRequired"
                              *ngIf="selectedComponent.type != ComponentType.TEXT && selectedComponent.type != ComponentType.BUTTON && selectedComponent.type !== ComponentType.TITLE && selectedComponent.type !== ComponentType.HTML && !selectedComponent.readOnly"
                              (ngModelChange)="newUpdateListener()">
                  {{ 'Required' | translate }}
                </mat-checkbox>
              </div>

            </mat-expansion-panel>

            <!-- answers -->
            <mat-expansion-panel #answersPanel class="right-side-bar-panel"
            *ngIf="selectedComponent.type != ComponentType.SCHEDULE &&
            selectedComponent.type != ComponentType.TEXT &&
            selectedComponent.type !== ComponentType.TITLE &&
            selectedComponent.type !== ComponentType.HTML &&
            selectedComponent.type !== ComponentType.CHECKBOX &&
            selectedComponent.type !== ComponentType.ADDRESS &&
            selectedComponent.type !== ComponentType.INTITULE">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Answers" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field">
                <mat-checkbox [checked]="selectedComponent.config!.hasColorText"
                              [(ngModel)]="selectedComponent.config!.hasColorText"
                              *ngIf="selectedComponent.type === ComponentType.INPUT && selectedComponent.config?.inputType === InputType.COLOR_PICKER"
                              (ngModelChange)="newUpdateListener()">
                  {{ 'Color picker text' | translate }}
                </mat-checkbox>
              </div>

              <div class="cdc-form-field actif"
              *ngIf="selectedComponent.type == ComponentType.BUTTON
              || (selectedComponent.type == ComponentType.SELECT && selectedComponent.config?.selectType === SelectType.LIST_DROP)
              || (selectedComponent.type == ComponentType.INPUT && selectedComponent.config!.inputType != InputType.FILE && selectedComponent.config?.inputType != InputType.COLOR_PICKER && selectedComponent.config?.inputType != InputType.DATE)
              || (selectedComponent.config?.inputType == InputType.COLOR_PICKER && selectedComponent.config?.hasColorText === true)">
                <div class="cdc-label">
                  <ng-container *ngIf="selectedComponent.type === ComponentType.BUTTON; else placeholderText">
                    {{ 'Name' | translate }}
                  </ng-container>
                  <ng-template #placeholderText>
                    {{ 'Placeholder' | translate }}
                  </ng-template>
                </div>

                <input matInput type="text" [(ngModel)]="selectedComponent.config!.placeholder" (ngModelChange)="newUpdateListener()">
              </div>

              <div class="cdc-form-field actif"
              *ngIf="selectedComponent.type == ComponentType.BUTTON
              || (selectedComponent.type == ComponentType.INPUT && selectedComponent.config!.inputType == InputType.FILE)
              || selectedComponent.type == ComponentType.VISUAL_PUBLICATION">
                <div class="cdc-label">
                  <ng-container *ngIf="selectedComponent.type === ComponentType.BUTTON; else placeholderText">
                    {{ 'Link' | translate }}
                  </ng-container>
                  <ng-template #placeholderText>
                    {{ 'Text' | translate }}
                  </ng-template>
                </div>

                <textarea #autoResizeTextarea matInput [(ngModel)]="selectedComponent.config!.text" rows="1" (focusin)="adjustTextareaHeight($event)" (input)="adjustTextareaHeight($event)" class="general-text-area" (focusout)="fixText($event, 'text')"></textarea>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type == ComponentType.INPUT && selectedComponent.config!.inputType == InputType.FILE">
                <div class="cdc-label">
                  {{ "File type" | translate }}
                </div>
                <mat-form-field class="mt-1 d-flex flex-column select-container file-type">
                  <!-- <mat-label>{{ 'File Type' | translate }}</mat-label> -->
                  <mat-select [(value)]="selectedComponent.config!.fileType" multiple (selectionChange)="newUpdateListener()">
                    <mat-option matTooltip="{{getExtensions(type)}}" *ngFor="let type of fileTypes" [value]="type">{{ type | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type == ComponentType.VISUAL_PUBLICATION">
                <div class="cdc-label">
                  {{ "File type" | translate }}
                </div>
                <select [(ngModel)]="selectedComponent.config!.contentAPISubType" inactif matNativeControl (ngModelChange)="onVisualPublicationTypeChange()">
                  <option value="LOGO">{{'LOGO' | translate}}</option>
                  <option value="PHOTO">{{'PHOTO' | translate}}</option>
                </select>
              </div>

              <div class="cdc-form-field actif" *ngIf="selectedComponent.type == ComponentType.URL">
                <div class="cdc-label">
                  {{ "URL type" | translate }}
                </div>
                  <select [(ngModel)]="selectedComponent.config!.contentAPISubType" inactif matNativeControl (ngModelChange)="newUpdateListener()">
                    <option value="CUSTOM">{{'Custom' | translate}}</option>
                    <option disabled>──────────</option>
                    <option *ngFor="let type of refBusinessLists.urlTypes" [value]="type.code">{{ type.labelBusiness }}</option>
                  </select>
              </div>

              <div class="cdc-form-field" *ngIf="
                selectedComponent.type == ComponentType.SELECT
                || selectedComponent.type == ComponentType.INPUT
                || selectedComponent.type == ComponentType.URL
                || selectedComponent.type == ComponentType.VISUAL_PUBLICATION">
                <mat-checkbox [checked]="selectedComponent.config!.multipleAnswers"
                              [(ngModel)]="selectedComponent.config!.multipleAnswers"
                              (ngModelChange)="resetMultipleConfig()"
                              [disabled]="!canChangeMultipleCheckbox()">
                  {{ 'Multiple answers' | translate }}
                </mat-checkbox>
              </div>

              <div *ngIf="selectedComponent.type === ComponentType.SELECT">

                <div class="cdc-form-field" *ngIf="selectedComponent.type === ComponentType.SELECT && selectedComponent.config?.selectType === SelectType.LIST_CARD" [ngClass]="{'actif': selectedComponent.columns! >= 1}">
                  <div class="cdc-label">
                    {{ "Columns" | translate }}
                  </div>
                  <input matInput type="number" [(ngModel)]="selectedComponent.columns" [min]="1" step="1" (ngModelChange)="onColumnsChanged($event)">
                </div>

                <div class="cdc-form-field" [ngClass]="{'actif': canChangeOptionsType()}">
                  <div class="cdc-label">{{ 'Option type' | translate }}</div>
                  <select [(ngModel)]="selectedComponent.config!.optionsType" inactif matNativeControl
                          (ngModelChange)="handleSelectOptionType($event)"
                          [disabled]="!canChangeOptionsType()">
                    <option *ngFor="let type of optionTypes" [value]="type.value">{{ type.key | translate }}</option>
                  </select>
                </div>

                <mat-card class="cdc-card" appearance="outlined" *ngIf="selectedComponent.config!.optionsType == OptionsType.CUSTOM">
                  <mat-card-header><div class="cdc-label">{{ 'Options' | translate }}</div></mat-card-header>
                  <mat-card-content cdkDropList
                                    #optionsList="cdkDropList"
                                    [cdkDropListData]="selectedComponent.config!.options!"
                                    (cdkDropListDropped)="dropOption($event)">
                    <div *ngFor="let option of selectedComponent.config?.options; let i = index" class="option-row d-flex flex-row align-items-center gap-1" cdkDrag style="background-color: white;">
                      <div class="cdc-form-field m-0 d-flex flex-column align-items-center col-4 col-lg-4 col-md-4">
                        <span *ngIf="i === 0">{{ "Value" | translate }}</span>

                        <div [tippy]="isJson(option.value) ? beautifyJSON(option.value) : ''" placement="left" theme="light-white">
                          <input matInput type="text" placeholder="{{ 'Value' | translate }}" class="key-input"
                                 [(ngModel)]="option.value"
                                 (ngModelChange)="onChangeOptionValue(option, $event)"
                                 [disabled]="isJson(option.value)">
                        </div>
                      </div>

                      <div class="cdc-form-field m-0 d-flex flex-column align-items-center col-4 col-lg-4 col-md-4">
                        <span *ngIf="i === 0">{{ "Display" | translate }}</span>
                        <div *ngIf="isHtml(option.display)" [tippy]="option.display" placement="left" theme="light-white">
                          <input matInput type="text" [value]="stripHtml(option.display)" disabled class="value-input">
                        </div>
                        <input *ngIf="!isHtml(option.display)" matInput type="text" [(ngModel)]="option.display" (ngModelChange)="newUpdateListener()" class="value-input" placeholder="{{ 'Display' | translate }}">
                      </div>

                      <button mat-icon-button (click)="onOpenOptionEditorModal(i)" matTooltip="{{ 'Advanced' | translate }}" [ngClass]="{'mt-3': i === 0}" class="col-2 col-lg-2 col-md-2">
                        <mat-icon>settings</mat-icon>
                      </button>

                      <button mat-icon-button (click)="removeOption(i)" matTooltip="{{ 'Delete' | translate }}" [ngClass]="{'mt-3': i === 0}" class="col-2 col-lg-2 col-md-2">
                        <mat-icon>remove_circle</mat-icon>
                      </button>

                      <mat-icon class="col-2 col-lg-2 col-md-2 drag-icon" matTooltip="{{ 'Drag' | translate }}" [ngClass]="{'mt-3': i === 0}" cdkDragHandle>drag_indicator</mat-icon>
                    </div>
                    <div class="add-option-row d-flex flex-row align-items-center gap-1 mt-2">
                      <button mat-icon-button (click)="addOption()" matTooltip="{{ 'Add option' | translate }}" class="col-2 col-lg-2 col-md-2" [disabled]="hasEmptyKeyOrValue()">
                        <mat-icon>add_circle</mat-icon>
                      </button>
                    </div>

                    <mat-error *ngIf="hasEmptyKeyOrValue()"><p>{{'All fields must be filled' | translate}}</p></mat-error>
                    <mat-error *ngIf="hasDuplicatedValues()"><p>{{'Repeated values' | translate}}</p></mat-error>
                  </mat-card-content>

                </mat-card>
              </div>

              <div *ngIf="selectedComponent.type !== ComponentType.BUTTON
              && selectedComponent.type !== ComponentType.SELECT
              && !(selectedComponent.type == ComponentType.INPUT && selectedComponent.config!.inputType == InputType.FILE)
              && selectedComponent.type != ComponentType.VISUAL_PUBLICATION
              && (selectedComponent.config?.multipleAnswers === true || (selectedComponent.type == ComponentType.ACTIVITY_PRESTATIONS && selectedGroup!.components.length > 1))">
                <app-multiple-config [multipleConfig]="selectedComponent.multipleConfig!"
                                     [isGroup]="false"
                                     [hasIndexText]="(selectedComponent.type === ComponentType.INPUT && selectedComponent.config?.inputType === InputType.COLOR_PICKER) ? selectedComponent.config?.hasColorText : true"
                                     [multipleAnswers]="selectedComponent.config!.multipleAnswers!"
                                     (multipleChange)="newUpdateListener()">
                </app-multiple-config>
              </div>

              <div *ngIf="selectedComponent.type == ComponentType.ACTIVITY_PRESTATIONS && selectedGroup!.components && selectedGroup!.components.length == 1">
                <app-multiple-config [multipleConfig]="selectedGroup!.multipleConfig!"
                                     [isGroup]="true"
                                     [hasIndexText]="true"
                                     class="cdc-list"
                                     (multipleChange)="newUpdateListener()">
                </app-multiple-config>
              </div>

            </mat-expansion-panel>

            <!-- key indicator -->
            <mat-expansion-panel #keyindicatorPanel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Key Indicator" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="cdc-form-field"
                   [ngClass]="{
                'actif': !disableKeyIndicatorWeight(selectedComponent)
              }">
                <div class="cdc-label">{{ 'Weigth' | translate }}</div>
                <div class="cdc-label-description">({{ 'Range between' | translate }} 0-100)</div>
                <input matInput type="number"
                       [(ngModel)]="selectedComponent.keyIndicator!.weight"
                       (ngModelChange)="onKeyIndicatorChange($event)"
                       [min]="0"
                       [max]="100"
                       [step]="1"
                       [disabled]="disableKeyIndicatorWeight(selectedComponent)"
                       [matTooltip]="disableKeyIndicatorWeight(selectedComponent) ? ('Disabled due to non-editable customer role or read only' | translate) : ''">
              </div>

            </mat-expansion-panel>

            <!-- roles -->
            <mat-expansion-panel #rolesPanel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Roles" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <app-roles [id]="selectedComponent.id" [roles]="selectedComponent.roles!" [fullRoles]="fullRoles" [type]="'component'" [isEditColumnVisible]="selectedComponent.type !== ComponentType.BUTTON && selectedComponent.type !== ComponentType.TEXT && selectedComponent.type !== ComponentType.TITLE && selectedComponent.type !== ComponentType.HTML && !selectedComponent.readOnly" (customerNotVisible)="resetFieldsOnRolesChange($event)" class="d-flex flex-column" (rolesChanged)="newUpdateListener()"></app-roles>

            </mat-expansion-panel>

            <!-- conditions -->
            <mat-expansion-panel #conditionsPanel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Conditions" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="d-flex flex-row gap-2">
                <div class="cdc-form-field actif col-6 col-lg-6 col-md-6" *ngIf="existConditionDisplay()">
                  <div class="cdc-label">{{ 'Position' | translate }}</div>
                  <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
                    <mat-select [(ngModel)]="selectedComponent.config!.conditionPosition">
                      <mat-option value="apart">{{ 'After' | translate }}</mat-option>
                      <mat-option value="closed" *ngIf="conditionClosedTargets.length > 0">{{ 'Inside' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="cdc-form-field actif col-6 col-lg-6 col-md-6" *ngIf="existConditionDisplay() && (selectedComponent.config!.conditionPosition != 'apart')">
                  <div class="cdc-label">{{ 'Target' | translate }}</div>
                  <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
                    <mat-select [(ngModel)]="selectedComponent.config!.conditionComponentTarget">
                      <mat-option *ngFor="let targetId of conditionClosedTargets" [value]="targetId">{{ getBlockComponentById(targetId)?.title }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="mt-3 d-flex flex-column" *ngFor="let condition of selectedComponent.conditions;let i = index">
                <app-condition [condition]="condition" [sourceComponent]="getBlockComponentById(condition.componentId)" [refBusinessLists]="refBusinessLists" (removeCondition)="onRemoveCondition(i)"></app-condition>
              </div>
              <div class="d-flex justify-content-center mt-3">
                <button mat-icon-button matTooltip="{{ 'Add condition' | translate }}" (click)="onAddCondition()" [disabled]="conditionSources.length === 0">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </div>

            </mat-expansion-panel>

            <!-- connections -->
            <mat-expansion-panel #connectionsPanel class="right-side-bar-panel">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>
                    {{"Connections" | translate}}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div cdkDropList
                  #connectionsList="cdkDropList"
                  [cdkDropListData]="selectedComponent.connections!"
                  (cdkDropListDropped)="dropConnection($event)"
              >
                <div class="mt-3 d-flex flex-column" *ngFor="let connection of selectedComponent.connections;let i = index" cdkDrag>
                  <app-connection
                  [connection]="connection"
                  [component]="selectedComponent"
                  [fullConnectionsDefinitions]="connectionsDefinitions"
                  (removeConnection)="onRemoveConnection(i)"
                  (updateSelectOptions)="updateSelectOptions($event)"
                  (onConnectionBuilded)="onConnectionBuilded($event)"></app-connection>
                </div>
              </div>


              <div class="d-flex justify-content-center mt-3">
                <button mat-icon-button matTooltip="{{ 'Add connection' | translate }}" (click)="onAddConnection()">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </div>

            </mat-expansion-panel>
          </mat-nav-list>

          <button mat-button class="cdc-button delete w-100" (click)="onRemoveComponent()">
            <span>{{'Delete' | translate}}</span>
            <mat-icon>delete</mat-icon>
          </button>

        </div>

      </mat-sidenav>
    </mat-sidenav-container>
  </div>
